let audioCtx;

function getAudioCtx() {
  audioCtx ??= new (window.AudioContext || window.webkitAudioContext)();
  // Chrome starts the context suspended unless created/resumed inside a user gesture
  if (audioCtx.state === "suspended") audioCtx.resume();
  return audioCtx;
}

// Scan/analysis results arrive async (no user gesture), so unlock audio on the first tap.
if (typeof window !== "undefined") {
  const events = ["pointerdown", "touchend", "click"];
  const unlock = () => {
    try {
      const ctx = getAudioCtx();
      // iOS only unlocks audio if a sound actually plays inside a touchend/click gesture
      const src = ctx.createBufferSource();
      src.buffer = ctx.createBuffer(1, 1, 22050);
      src.connect(ctx.destination);
      src.start(0);
      if (ctx.state === "running") {
        events.forEach((e) => window.removeEventListener(e, unlock, true));
      }
    } catch {
      // no Web Audio support
    }
  };
  events.forEach((e) => window.addEventListener(e, unlock, true));
}

// Short beep + vibration. Vibration is a no-op on iOS Safari and desktop browsers.
export function beepAndVibrate() {
  try {
    navigator.vibrate?.(150);
    const ctx = getAudioCtx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.frequency.value = 1000;
    gain.gain.value = 0.2;
    osc.connect(gain).connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + 0.15);
  } catch {
    // feedback is best-effort
  }
}
